import { FC, useId } from "react";

export const MellowIcon: FC<{ className?: string }> = ({ className }) => {
  const id = useId();

  const clipPathId0 = `mellow-clip-path-0-${id}`;
  const maskId0 = `mellow-mask-0-${id}`;
  const fillId0 = `mellow-fill-0-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clip-path={`url(#${clipPathId0})`}>
        <mask
          id={maskId0}
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <path d="M16 0H0V16H16V0Z" fill="white" />
        </mask>
        <g mask={`url(#${maskId0})`}>
          <path
            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
            fill={`url(#${fillId0})`}
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.79999 13.6C11.8928 13.6 14.4 11.0928 14.4 8.00001C14.4 4.90721 11.8928 2.40001 8.79999 2.40001C5.7072 2.40001 3.19999 4.90721 3.19999 8.00001C3.19999 11.0928 5.7072 13.6 8.79999 13.6ZM8.79999 14.4C12.3346 14.4 15.2 11.5346 15.2 8.00001C15.2 4.46538 12.3346 1.60001 8.79999 1.60001C5.26537 1.60001 2.39999 4.46538 2.39999 8.00001C2.39999 11.5346 5.26537 14.4 8.79999 14.4Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.4 10.4C11.7255 10.4 12.8 9.32551 12.8 7.99999C12.8 6.67451 11.7255 5.59999 10.4 5.59999C9.07448 5.59999 8 6.67451 8 7.99999C8 9.32551 9.07448 10.4 10.4 10.4ZM10.4 11.2C12.1673 11.2 13.6 9.76727 13.6 7.99999C13.6 6.23268 12.1673 4.79999 10.4 4.79999C8.63272 4.79999 7.2 6.23268 7.2 7.99999C7.2 9.76727 8.63272 11.2 10.4 11.2Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={fillId0}
          x1="8"
          y1="0"
          x2="8"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F50D3C" />
          <stop offset="1" stop-color="#D7002B" />
        </linearGradient>
        <clipPath id={clipPathId0}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
